import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    versions: null,
  },
  getters: {
    getVersionsList: state => state.versions,
  },
  mutations: {
    SET_VERSIONS_LIST(state, list) {
      state.versions = list
    },
  },
  actions: {
    searchPlaces(_, { text }) {
      return axiosIns.get(`pricing/google/search/${text}`)
    },
    getPlaceLatLong(_, { placeId }) {
      return axiosIns.get(`pricing/google/gedocode/${placeId}`)
    },
    distanceMatrix(_, params) {
      return axiosIns.get('pricing/google/distance-matrix', {
        params,
      })
    },
    async fetchVersions({ commit }, {
      selectedZone, selectedService, businessId, distinct, published, limit, withDetails,
    }) {
      commit('SET_VERSIONS_LIST', null)
      const res = await axiosIns.get('pricing/versions', {
        params: {
          zone: selectedZone,
          service_class: selectedService,
          business_id: businessId,
          details: withDetails,
          distinct,
          limit,
          published,
        },
      })
      commit('SET_VERSIONS_LIST', res.data.data)
      return res.data.data
    },
    createVersion(_, version) {
      return axiosIns.post('pricing/versions', version)
    },
    editVersion(_, { id, version }) {
      return axiosIns.patch(`pricing/versions/${id}`, version)
    },
    getVersion(_, { versionId, zone, service }) {
      if (!versionId) {
        return axiosIns.get('/pricing/versions/new/', {
          params: {
            zone,
            service,
          },
        })
      }
      return axiosIns.get(`pricing/versions/${versionId}`)
    },
    async testVersion(_, version) {
      return axiosIns.post('pricing/versions/calculations/stateless', version)
    },
    deleteVersion(_, id) {
      return new Promise((resolve, reject) => {
        axiosIns.delete(`pricing/versions/${id}`)
          .then(() => {
            resolve()
          }).catch(err => reject(err))
      })
    },
  },
}
